import { ModelBase } from 'store/model-base';

export class CmsSettings extends ModelBase {
    public static storeName: string = 'cmsSettings';

    public landing: CmsSettingsLanding;
    public contact: CmsSettingsContact;
    public editCard: CmsSettingsEditCard;
}
